"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EQualiteRepresentantTrads = void 0;
exports.EQualiteRepresentantTrads = {
    president: "Président(e)",
    gerant: "Gérant(e)",
    signataire: "Signataire",
};
